export const SCROLL_CONTAINER_ID = 'scroll-container';
export const MAIN_CONTENT_CONTAINER_ID = 'main-content-container';
export const SIDEBAR_FOOTER_ID = 'sidebar-footer';

export enum SessionFeatures {
  HideNewsAlert = 'hideNewsAlert',
}
